import React, { useState, useEffect } from 'react';
import { useHistory, withRouter } from "react-router-dom";
import {
    Modal,
    Select,
    Form,
    Row,
    Col,
    Typography,
    message,
    Table,
    Button,
} from "antd";
import moment from "moment";
import { platformApi } from '../../../../api';
const { Text, Title } = Typography;

const formatLogDuration = (totalSecs) => {
    const s = Number(totalSecs);
    if (isNaN(s)) return "00:00:00";
    const hrs = Math.floor(s / 3600);
    const mins = Math.floor((s % 3600) / 60);
    const secs = s % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

const JobOrderLogs = ({
    form,
    open,
    close,
    data,
    editable,
    modify,
    setVData,
    setVOpen
}) => {
    const jobItemData = {
        "event": '',
        "data": '',
        "dateTime": '',
    }
    const history = useHistory();
    const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
    const [dataSource, setDataSource] = useState([jobItemData])
    useEffect(() => {
        if (data) {
            console.log("editData", data)
            platformApi.get('/api/jobOrderlog/getLogs/' + data.id)
                .then((res) => {
                    let { data } = res;
                    if (data.code === 200) {
                        let { response } = data;
                        if (response.code === 200) {
                            let rawList = [...response.data];
                            let updateItemList = [];
                            for (let i = 0; i < rawList.length; i++) {
                                const item = rawList[i];
                                const prev = updateItemList[updateItemList.length - 1];
                                const isSameEvent = prev && prev.event === item.event;
                                const isCloseTime = prev && Math.abs(new Date(prev.createdAt) - new Date(item.createdAt)) < 15000;
                                const isDuplicatePartsIssued = isSameEvent && (item.event === "Parts Issued" || item.event === "Material Issued") && isCloseTime;

                                if (
                                    prev &&
                                    isSameEvent &&
                                    (prev.data === item.data || isDuplicatePartsIssued) &&
                                    isCloseTime
                                ) {
                                    if (isDuplicatePartsIssued && (!prev.data || prev.data === "Parts Issued") && item.data) {
                                        updateItemList[updateItemList.length - 1] = item;
                                    }
                                    continue;
                                }
                                updateItemList.push(item);
                            }

                            for (let i = 0; i < updateItemList.length; i++) {
                                if (updateItemList[i].event === "Job Order Created") {
                                    updateItemList[i].data = updateItemList[i].jobOrder?.jobNo || updateItemList[i].data;
                                }
                                else if (updateItemList[i].event === "Vehicle Received") {
                                    updateItemList[i].data = (updateItemList[i].jobOrder?.vehicle && updateItemList[i].jobOrder.vehicle.registerNo) || updateItemList[i].data;
                                }
                                else if (updateItemList[i].event === "Mechanic Allocated") {
                                    const raw = updateItemList[i].data;
                                    let parsedMech = null;
                                    if (typeof raw === "string" && raw.trim().startsWith("{")) {
                                        try { parsedMech = JSON.parse(raw); } catch (e) { parsedMech = null; }
                                    }
                                    if (parsedMech && typeof parsedMech === "object") {
                                        const name = parsedMech.mechanicName || "-";
                                        const prev = parsedMech.previousMechanicName
                                            ? ` | Prev: ${parsedMech.previousMechanicName}`
                                            : "";
                                        const elapsed =
                                            parsedMech.elapsedSeconds !== undefined && parsedMech.elapsedSeconds !== null
                                                ? ` | Timer at assign: ${formatLogDuration(parsedMech.elapsedSeconds)}`
                                                : "";
                                        const action = parsedMech.action === "reassignMechanic" ? "Reassigned" : "Allocated";
                                        updateItemList[i].data = `${action}: ${name}${prev}${elapsed}`;
                                    } else {
                                        const isCuid = typeof raw === 'string' && raw.length === 25 && raw.startsWith('c');
                                        if (isCuid || !raw) {
                                            updateItemList[i].data = (updateItemList[i].jobOrder?.mechanic && updateItemList[i].jobOrder.mechanic.profile)
                                                ? `${updateItemList[i].jobOrder.mechanic.profile.employeeId} - ${updateItemList[i].jobOrder.mechanic.profile.employeeName}`
                                                : "-";
                                        }
                                    }
                                }
                                else if (updateItemList[i].event === "Work In Progress" || updateItemList[i].event === "Work Started") {
                                    const raw = updateItemList[i].data;
                                    let parsedStart = null;
                                    if (typeof raw === "string" && raw.trim().startsWith("{")) {
                                        try { parsedStart = JSON.parse(raw); } catch (e) { parsedStart = null; }
                                    }
                                    if (parsedStart && parsedStart.elapsedSeconds !== undefined) {
                                        const mech = parsedStart.mechanicName ? ` | ${parsedStart.mechanicName}` : "";
                                        updateItemList[i].data = `Started at ${formatLogDuration(parsedStart.elapsedSeconds)}${mech}`;
                                    } else if (updateItemList[i].event === "Work In Progress") {
                                        updateItemList[i].data = updateItemList[i].jobOrder?.jobNo || updateItemList[i].data;
                                    }
                                }
                                updateItemList[i].dateTime = updateItemList[i].createdAt;
                            }
                            setDataSource(updateItemList);
                        }
                    }
                    else {
                        message.error("Unable to get Job Order Logs", 2);
                    }
                })
                .catch((err) => {
                    message.error("Unable to get Job Order Logs", 2);
                    console.error("Error on Job Order Logs : ", err);
                });



        }
    }, [data]);

    const clearFieldsAndClose = () => {
        form.resetFields();
        close();
        history.push('/autoadmin/job_order');
    };
    const columns = [
        {
            title: "Event",
            align: "center",
            dataIndex: "event",
            key: "event",
            render: (record) => <span>{record}</span>,
        },
        {
            title: "Data",
            align: "center",
            dataIndex: "data",
            key: "data",
            render: (record, data) => {
                if (typeof record === "string" && record.endsWith(".mp3")) {
                    return (
                        <audio controls style={{ width: '100%', height: '30px' }}>
                            <source src={record} type="audio/mpeg" />
                            Your browser does not support the audio element.
                        </audio>
                    );
                }

                let displayValue = record && record;
                let parsed = null;
                if (typeof record === "string" && (record.startsWith("{") || record.startsWith("["))) {
                    try {
                        parsed = JSON.parse(record);
                    } catch (e) {
                        parsed = null;
                    }
                } else if (typeof record === "object" && record !== null) {
                    parsed = record;
                }

                if (data.event === "Claim Intimated" || data.event === "Surveyor Appointed") {
                    if (parsed) {
                        const claimNo = parsed.claimNumber ? `Claim No: ${parsed.claimNumber}` : "";

                        let surveyorName = "";
                        if (parsed.Customer && parsed.Customer.name) {
                            surveyorName = parsed.Customer.name;
                        } else if (parsed.surveyor) {
                            surveyorName = parsed.surveyor;
                        }
                        const surveyor = surveyorName ? `Surveyor: ${surveyorName}` : "";

                        if (data.event === "Claim Intimated") {
                            displayValue = claimNo || "Details Updated";
                        } else if (data.event === "Surveyor Appointed") {
                            displayValue = surveyor || "Details Updated";
                        } else {
                            displayValue = [claimNo, surveyor].filter(Boolean).join(" | ") || "Details Updated";
                        }
                    } else {
                        displayValue = record || "Details Updated";
                    }
                } else if (data.event === "Estimation" || data.event === "Estimate Generated") {
                    if (parsed) {
                        if (parsed.estimateNo) {
                            const amt = parsed.totalEstimate || parsed.total;
                            displayValue = `Estimate No: ${parsed.estimateNo}${amt ? ` (₹${Number(amt).toFixed(0)})` : ''}`;
                        } else if (parsed.Insurance || parsed.insurer || parsed.claimType) {
                            const insurerName = parsed.Insurance?.name || parsed.insurer?.name || "";
                            const claimType = parsed.claimType || "";
                            const claimNo = parsed.claimNumber ? `Claim No: ${parsed.claimNumber}` : "";
                            displayValue = [insurerName && `Insurer: ${insurerName}`, claimType && `Type: ${claimType}`, claimNo].filter(Boolean).join(" | ") || "Estimation Updated";
                        } else {
                            displayValue = "Estimate Generated";
                        }
                    } else if (typeof record === "string" && record.length === 25 && record.startsWith("c")) {
                        displayValue = "Estimate Generated";
                    } else if (record) {
                        displayValue = String(record).startsWith("EST") ? `Estimate No: ${record}` : String(record);
                    } else {
                        displayValue = "Estimate Generated";
                    }
                } else if (
                    data.event === "Payment Completed" ||
                    data.event === "Job Invoice" ||
                    data.event === "PAID" ||
                    data.event === "Proforma Invoice"
                ) {
                    if (parsed) {
                        const invNo = parsed.invoiceNumber || parsed.invoiceNo;
                        displayValue = invNo ? `Invoice No: ${invNo}` : data.event;
                    } else if (record && typeof record === "string") {
                        displayValue = (record.startsWith("SS") || record.startsWith("INV")) ? `Invoice No: ${record}` : record;
                    } else {
                        displayValue = data.event;
                    }
                } else if (
                    data.event === "Spares Ordered" ||
                    data.event === "Spare Order Created" ||
                    data.event === "Spares Partially Ordered" ||
                    data.event === "Spare Received" ||
                    data.event === "Spares Received"
                ) {
                    if (parsed) {
                        const orderNo = parsed.orderNumber || parsed.orderNo;
                        const count = parsed.itemsCount ? ` (${parsed.itemsCount} items)` : "";
                        displayValue = orderNo ? `Order No: ${orderNo}${count}` : data.event;
                    } else if (record) {
                        displayValue = (String(record).startsWith("CSO") || String(record).startsWith("SPO")) ? `Order No: ${record}` : String(record);
                    } else {
                        displayValue = data.event;
                    }
                } else if (data.event === "Parts Issued" || data.event === "Material Issued") {
                    if (parsed) {
                        const slipNo = (parsed.slipNumber !== undefined && parsed.slipNumber !== null)
                            ? parsed.slipNumber
                            : ((parsed.slipNo !== undefined && parsed.slipNo !== null) ? parsed.slipNo : "");
                        displayValue = slipNo !== "" ? `Slip No: ${slipNo}` : data.event;
                    } else if (typeof record === "string" && record.length === 25 && record.startsWith("c")) {
                        displayValue = "Parts Issued";
                    } else if (record && !isNaN(record)) {
                        displayValue = `Slip No: ${record}`;
                    } else if (record) {
                        displayValue = String(record).startsWith("Slip") ? String(record) : `Slip No: ${record}`;
                    } else {
                        displayValue = data.event;
                    }
                } else if (data.event === "Labour Performed" || data.event === "Labour Perform") {
                    if (parsed) {
                        const slipNo = (parsed.slipNumber !== undefined && parsed.slipNumber !== null)
                            ? parsed.slipNumber
                            : ((parsed.slipNo !== undefined && parsed.slipNo !== null) ? parsed.slipNo : "");
                        displayValue = slipNo !== "" ? `Slip No: ${slipNo}` : "Labour Performed";
                    } else if (typeof record === "string" && record.length === 25 && record.startsWith("c")) {
                        displayValue = "Labour Performed";
                    } else if (record && !isNaN(record)) {
                        displayValue = `Slip No: ${record}`;
                    } else {
                        displayValue = data.event;
                    }
                } else if (
                    data.event === "Work Paused" ||
                    data.event === "Work Resumed" ||
                    data.event === "Work Started" ||
                    data.event === "Work Completed" ||
                    data.event === "Work Stopped" ||
                    data.event === "Washing"
                ) {
                    try {
                        const p = parsed || (typeof record === "string" ? JSON.parse(record) : record);
                        const duration = p && p.elapsedSeconds !== undefined ? formatLogDuration(p.elapsedSeconds) : null;
                        if (data.event === "Work Completed" || data.event === "Washing") {
                            displayValue = duration ? `Total Job Time: ${duration}` : "Work Completed";
                        } else if (data.event === "Work Stopped") {
                            // Non-mech Stop: revert to previous section
                            const reverted = p?.revertedStatus || p?.previousStatus;
                            displayValue = duration
                                ? `Stopped at ${duration}${reverted ? ` | Reverted to: ${reverted}` : ""}`
                                : reverted
                                  ? `Work Stopped | Reverted to: ${reverted}`
                                  : "Work Stopped";
                        } else if (data.event === "Work Paused") {
                            // Mechanic Pause: stay on current status
                            const stayed = p?.stayedOnStatus;
                            displayValue = duration
                                ? `Paused at ${duration}${stayed ? ` | Stayed on: ${stayed}` : ""}`
                                : stayed
                                  ? `Work Paused | Stayed on: ${stayed}`
                                  : "Work Paused";
                        } else if (data.event === "Work Resumed") {
                            displayValue = duration ? `Resumed from ${duration}` : "Work Resumed";
                        } else if (data.event === "Work Started") {
                            const mech = p?.mechanicName ? ` | ${p.mechanicName}` : "";
                            displayValue = duration
                                ? `Work Started (${duration})${mech}`
                                : `Work Started${mech}`;
                        } else {
                            displayValue = duration ? `Elapsed Time: ${duration}` : "Timer Updated";
                        }
                    } catch (e) {
                        if (!isNaN(record) && record !== "" && record !== null) {
                            displayValue = `Total Job Time: ${formatLogDuration(record)}`;
                        } else {
                            displayValue = data.event === "Washing" ? "Washing" : (record || "Completed");
                        }
                    }
                } else if (data.event === "Final Inspection Completed" || data.event === "Final Inspection Draft Saved" || data.event === "Final Inspection") {
                    try {
                        const p = parsed || (typeof record === "string" ? JSON.parse(record) : record);
                        if (p && p.finalComment) {
                            displayValue = `Final Inspection Completed | Note: ${p.finalComment}`;
                        } else if (p && p.elapsedSeconds !== undefined) {
                            displayValue = `Final Inspection | Total Job Time: ${formatLogDuration(p.elapsedSeconds)}`;
                        } else {
                            displayValue = data.event;
                        }
                    } catch (e) {
                        displayValue = record || data.event;
                    }
                } else if (data.event === "Final Inspection Redo") {
                    try {
                        const p = parsed || (typeof record === "string" ? JSON.parse(record) : record);
                        const prev = p?.previousStatus ? ` | previousStatus: ${p.previousStatus}` : "";
                        const elapsed =
                            p?.elapsedSeconds !== undefined
                                ? ` | Elapsed: ${formatLogDuration(p.elapsedSeconds)}`
                                : "";
                        displayValue = `Sent back to WIP — use Start Work to continue${prev}${elapsed}`;
                    } catch (e) {
                        displayValue = "Final Inspection Redo → WIP (Start Work to continue)";
                    }
                } else if (parsed && typeof parsed === "object") {
                    displayValue = parsed.note || parsed.message || parsed.status || data.event;
                }

                const isClickable =
                    data.event === "Vehicle Received" ||
                    data.event === "Material Issued" ||
                    data.event === "Parts Issued" ||
                    data.event === "Labour Performed" ||
                    data.event === "Labour Perform" ||
                    data.event === "Estimate Generated" ||
                    data.event === "Estimation" ||
                    data.event === "Payment Completed" ||
                    data.event === "Job Invoice" ||
                    data.event === "Proforma Invoice" ||
                    data.event === "Spares Ordered" ||
                    data.event === "Spare Received" ||
                    data.event === "Spares Partially Ordered";

                const handleClick = () => {
                    if (data.event === "Vehicle Received") {
                        setVData(data.jobOrder?.vehicle);
                        setVOpen(true);
                        return;
                    }
                    // Close logs modal before navigating to the form
                    if (typeof close === "function") close();
                    if (data.event === "Material Issued" || data.event === "Parts Issued") {
                        const miId = parsed?.id || (typeof record === "string" && record.startsWith("c") && record.length === 25 ? record : null);
                        if (miId) {
                            history.push(`/autoadmin/material_issue/${miId}`);
                        } else {
                            history.push('/autoadmin/material_issue');
                        }
                    } else if (data.event === "Labour Performed" || data.event === "Labour Perform") {
                        const lpId = parsed?.id || (typeof record === "string" && record.startsWith("c") && record.length === 25 ? record : null);
                        if (lpId) {
                            history.push(`/autoadmin/labour_perform/${lpId}`);
                        } else {
                            history.push('/autoadmin/labour_perform');
                        }
                    } else if (data.event === "Estimate Generated" || data.event === "Estimation") {
                        const estId = parsed?.id || (typeof record === 'string' && record.startsWith('c') && record.length === 25 ? record : null);
                        if (estId) {
                            history.push(`/autoadmin/estimate/${estId}`);
                        } else {
                            history.push('/autoadmin/estimate');
                        }
                    } else if (data.event === "Payment Completed" || data.event === "Job Invoice" || data.event === "Proforma Invoice") {
                        const invId =
                            parsed?.invoiceId ||
                            parsed?.id ||
                            (typeof record === "string" && record.startsWith("c") && record.length === 25
                                ? record
                                : null);
                        if (invId) {
                            history.push(`/autoadmin/job_invoice/${invId}`);
                        } else {
                            history.push('/autoadmin/job_invoice');
                        }
                    } else if (data.event === "Spares Ordered" || data.event === "Spare Received" || data.event === "Spares Partially Ordered") {
                        history.push('/autoadmin/customer_spares_order');
                    }
                };

                return (
                    <span
                        className={isClickable ? "linkylink" : ""}
                        onClick={handleClick}
                    >
                        {displayValue}
                    </span>
                );
            },
        },
        {
            title: "Date & Time",
            align: "center",
            dataIndex: "dateTime",
            key: "dateTime",
            render: (record) => <span>{moment(record).format("DD-MM-YYYY hh:mm:ss A")}</span>,
        },
    ];

    return (
        <Modal
            width="60%"
            title={<Title level={4}>JobOrder Logs</Title>}
            visible={open}
            onCancel={clearFieldsAndClose}
            onOk={clearFieldsAndClose}
        >
            <Form className="logs-form">
                <Row>
                    <Col span={12}>
                        <Text strong>
                            JOB NO&nbsp;&nbsp;&nbsp;: {data && data.jobNo}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Table
                        style={{ marginTop: '1rem' }}
                        columns={columns}
                        tableLayout="fixed"
                        dataSource={dataSource}
                    />
                </Row>
            </Form>
        </Modal>
    )
}
const WrappedJobOrderLogs = Form.create("joborder_logs")(
    JobOrderLogs
);

export default WrappedJobOrderLogs;